<template>
    <div>
        <h2 v-if="product.Name" class="h2 cabinet-title pt-1">
            {{ product.Name }}
        </h2>
        <h2 v-else class="h2 cabinet-title pt-1">
            {{ product.type.Name }} {{ product.Article }}
        </h2>
        <div class="subtitle1 pt-2">
            {{ getFormattedNum(parseInt(product.Price) || 0) }}
            ₽{{ priceUnit }}
        </div>
        <div class="pt-3">
            <router-link
                :to="{
                    name: 'SupplierProductsEdit',
                    params: { id: $route.params.id }
                }"
                tag="button"
                class="cabinet-btn"
                :class="btnClass"
                >Редактировать</router-link
            >
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import getFormattedNum from '@/utils/getFormattedNum'
import getNameById from '@/mixins/getNameById'

export default {
    name: 'DetailHead',
    mixins: [getNameById],
    props: {
        btnClass: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapState('supplierProducts', ['product']),
        ...mapState('other', ['priceUnitOptions']),
        priceUnit() {
            const unit = this.getNameById(
                this.priceUnitOptions,
                'abbr',
                'id',
                this.product.PriceUnit
            )

            return unit ? `/${unit}` : ''
        }
    },
    methods: {
        getFormattedNum
    }
}
</script>
